import {append} from 'ramda'

import {
  HideOverlayParams,
  ModuleActionType,
  OVERLAY_HIDE,
  OVERLAY_SHOW,
  OVERLAY_STACK_REPLACE,
  OVERLAY_SYNC_TO_URL,
  ReplaceOverlaysParams,
  ShowOverlayParams,
  SyncOverlayToUrlParams
} from './actions'
import {OVERLAY_IDS} from './constants'

export type OverlayStateItemType = {
  extraState?: Record<string, unknown> | null
  id: string
}

export type OverlayStateType = OverlayStateItemType[]

const initialState: OverlayStateType = []

// Restrict URL-driven reopen to known UI overlays; ignore unknown ids in the URL.
const RESTORABLE_OVERLAY_IDS = new Set<string>(Object.values(OVERLAY_IDS))

export default (
  state: OverlayStateType = initialState,
  action: ModuleActionType
): OverlayStateType => {
  switch (action.type) {
    case OVERLAY_SHOW:
      return append<OverlayStateItemType>(
        action.params as ShowOverlayParams,
        state
      )

    case OVERLAY_HIDE:
      return state.filter(
        overlay => overlay.id !== (action.params as HideOverlayParams).id
      )

    case OVERLAY_STACK_REPLACE:
      return (action.params as ReplaceOverlaysParams).overlays

    case OVERLAY_SYNC_TO_URL: {
      const {targetId} = action.params as SyncOverlayToUrlParams

      // No overlay in the URL: close everything (browser back to base).
      if (!targetId) return state.length ? [] : state

      const idx = state.findIndex(overlay => overlay.id === targetId)

      if (idx === -1) {
        return RESTORABLE_OVERLAY_IDS.has(targetId)
          ? append<OverlayStateItemType>({id: targetId}, state)
          : state
      }

      // An overlay above the URL's top was closed via back: truncate to match.
      return idx < state.length - 1 ? state.slice(0, idx + 1) : state
    }

    default:
      return state
  }
}
